import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const courseCardDefaultVariants = {
  "color": "primary"
}
const courseCardCompoundVariants = []

const courseCardSlotNames = [
  [
    "root",
    "course-card__root"
  ],
  [
    "topContent",
    "course-card__topContent"
  ],
  [
    "metaWrapper",
    "course-card__metaWrapper"
  ],
  [
    "infoWrapper",
    "course-card__infoWrapper"
  ],
  [
    "contentWrapper",
    "course-card__contentWrapper"
  ],
  [
    "bottomContent",
    "course-card__bottomContent"
  ],
  [
    "title",
    "course-card__title"
  ]
]
const courseCardSlotFns = /* @__PURE__ */ courseCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, courseCardDefaultVariants, getSlotCompoundVariant(courseCardCompoundVariants, slotName))])

const courseCardFn = memo((props = {}) => {
  return Object.fromEntries(courseCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const courseCardVariantKeys = [
  "color"
]
const getVariantProps = (variants) => ({ ...courseCardDefaultVariants, ...compact(variants) })

export const courseCard = /* @__PURE__ */ Object.assign(courseCardFn, {
  __recipe__: false,
  __name__: 'courseCard',
  raw: (props) => props,
  variantKeys: courseCardVariantKeys,
  variantMap: {
  "color": [
    "primary",
    "neutral"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, courseCardVariantKeys)
  },
  getVariantProps
})